<mat-card  class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Debtors distribution</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-mat-table-generator #matTable [tableName]="'debtorsTable'" *ngIf="debtorsDataSource"
      [multiselectEnabled]="false"
      [columns]="debtorsColumns" 
      [dataSource]="debtorsDataSource"
      [viewLink]="getViewLink">
    </app-mat-table-generator>
  </mat-card-content>
</mat-card>